export default {
  // 知识库
  knowledge: {
    all: '全部知识',
    mycreate: '我创建的',
    mydepartment: '我部门的',
    mycollection: '我收藏的',
    myinvite: '邀我回答',
    item: '条',
    knowledgeClassify: '知识分类',
    putQuestion: '提 问',
    addKnowledge: '新建知识',
    addKnowledge2: '新建知识库',
    addputQuestion: '新建提问',
    knowledgeNote: '传承智慧，启迪未来。',
    putQuestionNote: '提出问题，寻找答案。',
    label: '标签',
    publishedIn: '发布于',
    read: '阅读',
    collection: '收藏',
    praise: '点赞',
    GeAnswer: '个回答',
    answer: '回答',
    loadMore: '加载更多…',
    video: '视频',
    title_empty: '标题不能为空',
    content_empty: '内容不能为空',
    classify_empty: '分类不能为空',
    basicInfo: '基本信息',
    title: '标题',
    videoName: '视频名称',
    videoLink: '视频地址',
    videoPlaceholder: '请将外部媒体地址粘贴至输入框',
    supportTip: '支持腾讯视频、优酷、爱奇艺、土豆。',
    addVideo: '添加视频',
    quote: '引用',
    addContent: '添加内容',
    classify: '分类',
    attachment: '附件',
    supportExtension: '支持扩展名',
    addmemo: '新增备忘录',
    versionManage: '版本管理',
    writeAnswer: '写回答',
    showAll: '显示全部',
    inviteAnswer: '邀人回答',
    look: '查看',
    studied: '已学习',
    study: '学习',
    answerTimeOrder: '按回答时间顺序排序',
    updateTimeSort: '按更新时间顺序排序',
    top: '置顶',
    cancelTop: '取消置顶',
    move: '移动',
    cancelLearn: '取消学习',
    confirmLearn: '确认学习',
    liked: '已点赞',
    collected: '已收藏',
    on: '于',
    answeredTheQuestion: '回答了此问题',
    putUp: '收起',
    expand: '展开',
    learnTip:
      '如果你已经学习完该知识，请点击“确定”按钮，系统会将你的学习状态标记下来，以便管理员查询员工学习记录。',
    confirmtransferknowledge: '确认要将该知识',
    what: '吗',

    classifyManage: '分类管理',
    tagManage: '标签管理',
    dataquery: '数据查询',
    filedName: '字段名称',
    name: '名称',
    dragsortTip: '您可以用鼠标上下拖动字段名称，对选项顺序进行排序。',
    labelname: '标签名称',
    nolabelyet: '暂无标签~',
    categoryname: '分类名称',
    administrator: '管理员',
    defaultclassification: '默认分类',
    open: '公开',
    private: '私有',
    openTip: '公开（机构所有成员均可见此分类）',
    privateTip: '私有（只有加入成员可见此分类）',
    delclassTip: '删除后不可恢复，该分类的知识将被归属到默认分类中。',
    addcategories: '添加分类',
    newcategory: '新增分类',
    editcategories: '编辑分类',
    categoryname_empty: '分类名称不能为空',
    categorymember_empty: '分类成员不能为空',
    categoryadmin_empty: '分类管理员不能为空',
    newlabel: '新增标签',
    labelname_empty: '标签名称不能为空',
    edittab: '编辑标签',
    type: '类型',
    test: ''
  }
}
